<template>
  <a-badge
    :count="unreadNum"
    :show-zero="false"
    :offset="[8, -4]"
  >
    <div
      class="announcement"
      :wj-eid="$t('k_3d1a6848')"
      @click="click()"
    >
      <public-w-icon-show-new
        v-if="config.icon && isIconReady"
        class="announcement-icon"
        :value="config.icon"
      />
      <span
        v-if="config.name"
        class="title"
      >{{ config.name }}</span>
    </div>
  </a-badge>
</template>

<script>
import { mapState } from 'vuex';
import { getCompsList } from '@/utils/comps-loader';

export default {
  name: 'Announcement',
  props: {
    mode: {
      type: String,
      default: 'runtime',
    },
    config: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isIconReady: false,
    };
  },
  computed: {
    ...mapState({
      anncmntList: state => state.announcement.anncmntList,
    }),
    unreadNum() {
      return this.anncmntList.filter(anncmnt => !anncmnt.read).length;
    },
  },
  async created() {
    if (this.mode === 'preview') {
      await getCompsList({
        compsKey: ([
          'public-w-icon-show-new',
        ]),
        register: true,
      });
    }
    this.isIconReady = true;
  },
  methods: {
    click() {
      if (this.disabled) return false;
      this.$emit('click');
    },
  },
};
</script>

<style lang="scss" scoped>
.announcement {
  font-size: var(--xy-custom-nav-font-size);
  color: var(--xy-custom-nav-color);
  margin-left: var(--xy-custom-nav-multi-menu-title-gap);
  display: flex;
  align-items: center;
  gap: 2px;

  &:hover {
    color: var(--xy-custom-nav-hover-color);
    cursor: pointer;
  }

  .announcement-icon {
    width: var(--xy-custom-nav-link-icon-size);
    height: var(--xy-custom-nav-link-icon-size);
  }
}
</style>
